<template>
  <CustomTable :columns="columnsToFollowUpVisit" :openModal="handleOpen" type="FollowUpVisit" />
  <!-- 弹出框 -->
  <ADetail ref="aDetail" :recordId="appointId" />
</template>

<script setup>
import CustomTable from './CustomTable.vue'
import { columnsToFollowUpVisit } from '@/components/PatientFile/ModalBody/todo/config'
import { nextTick, ref } from 'vue'
import ADetail from '@/views/WorkPlace/components/Appoint/index.vue'
const aDetail = ref(null)
const appointId = ref('')

const handleOpen = data => {
  appointId.value = data.record.reserveId.toString()
  nextTick(() => {
    aDetail.value.mVisible = true
    aDetail.value.initDetail()
  })
}
</script>

<style lang="scss" scoped></style>
